import { render } from "./ResultsTable.vue?vue&type=template&id=6b70b866&scoped=true&ts=true"
import script from "./ResultsTable.vue?vue&type=script&lang=ts"
export * from "./ResultsTable.vue?vue&type=script&lang=ts"

import "./ResultsTable.vue?vue&type=style&index=0&id=6b70b866&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b70b866"]])

export default __exports__